"use strict";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccordionSection = exports.StyledIcon = exports.StyledAccordionButton = exports.StyledAccordionContent = exports.StyledAccordion = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("@widget-editor/shared");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledAccordion = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledAccordion",
  componentId: "cea925-0"
})(["width:100%;padding-top:24px;padding-bottom:24px;"]);

exports.StyledAccordion = StyledAccordion;

var StyledAccordionContent = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledAccordionContent",
  componentId: "cea925-1"
})(["display:\"block\";max-height:", ";overflow-y:", ";transition:padding 0.2s ease-out;padding-left:24px;padding-top:", ";padding-bottom:", ";"], function (props) {
  return props.isOpen ? 'none' : 0;
}, function (props) {
  return props.isOpen ? 'visible' : 'hidden';
}, function (props) {
  return props.isOpen ? "18px" : 0;
}, function (props) {
  return props.isOpen ? "18px" : 0;
});

exports.StyledAccordionContent = StyledAccordionContent;

var StyledAccordionButton = _styledComponents["default"].button.withConfig({
  displayName: "style__StyledAccordionButton",
  componentId: "cea925-2"
})(["display:block;height:25px;color:#393f44;font-size:16px;font-weight:500;line-height:25px;position:relative;padding-left:25px;cursor:pointer;border:none;background:none;outline:none;"]);

exports.StyledAccordionButton = StyledAccordionButton;
var StyledIcon = (0, _styledComponents["default"])(function (_ref) {
  var themeColor = _ref.themeColor,
      isOpen = _ref.isOpen,
      rest = _objectWithoutProperties(_ref, ["themeColor", "isOpen"]);

  return _react["default"].createElement(_shared.AccordionArrow, rest);
}).withConfig({
  displayName: "style__StyledIcon",
  componentId: "cea925-3"
})(["position:absolute;left:0;top:5px;stroke:", ";transform:", ";transition:transform 0.2s ease-out;"], function (props) {
  return props.themeColor;
}, function (props) {
  return props.isOpen ? 'rotate(0)' : 'rotate(-90deg)';
});
exports.StyledIcon = StyledIcon;

var StyledAccordionSection = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledAccordionSection",
  componentId: "cea925-4"
})(["padding-top:11px;padding-bottom:11px;position:relative;&:before{content:\" \";height:1px;width:calc(100% - 24px);display:block;position:absolute;top:0;background-color:#d2d3d6;margin-left:24px;}&:first-child{&:before{display:none;}}"]);

exports.StyledAccordionSection = StyledAccordionSection;